import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { environment } from '../../../environments/environment';

/**
 * Allows a route only in development builds (production === false).
 * Used to keep internal test surfaces (e.g. the API chat tester) out of
 * production. In a production build the route resolves to /login instead.
 */
@Injectable({
  providedIn: 'root'
})
export class DevModeGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    if (!environment.production) {
      return true;
    }
    return this.router.parseUrl('/login');
  }
}
